// Smart Sash Admin Panel - Device Registration Service
// Handles device registration flow via admin panel

import { RFIDAssignmentRequest, RFIDAssignmentRequestData } from '@/models';
import { axiosClient } from '../http/axiosClient';

const ENDPOINTS = {
  REQUEST: '/DeviceRegistration/request',
  CONFIRM: '/DeviceRegistration/confirm',
} as const;

export const deviceRegistrationService = {
  /**
   * Trigger a device registration request (sends VerificationCodeSentEvent via gRPC)
   */
  request: async (params: RFIDAssignmentRequest): Promise<RFIDAssignmentRequestData> => {
    const response = await axiosClient.post<string>(ENDPOINTS.REQUEST, params);

    return {
      success: true,
      expiresAt: response.data,
    };
  },

  /**
   * Backend uses the confirm endpoint to finalize a pending device registration request,
   * including cancellation from the onboarding flow.
   */
  finalizePendingRequest: async (params: RFIDAssignmentRequest): Promise<void> => {
    await axiosClient.post(ENDPOINTS.CONFIRM, params);
  },
};

export default deviceRegistrationService;
